"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4330],{

/***/ 89000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const OfferList = _ref => {
  let {
    items
  } = _ref;
  const data = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": items.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx,
      "url": item
    }))
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataOfferList",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OfferList);

/***/ }),

/***/ 14330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89000);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26869);
/* harmony import */ var src_utils_gtm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29590);
/* harmony import */ var src_utils_gtm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28173);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);











const Pagination = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(6319), __webpack_require__.e(3344), __webpack_require__.e(804), __webpack_require__.e(1937), __webpack_require__.e(7788)]).then(__webpack_require__.bind(__webpack_require__, 90285)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(90285)]
  }
});
const HomeOffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7620), __webpack_require__.e(2732), __webpack_require__.e(6917), __webpack_require__.e(4188)]).then(__webpack_require__.bind(__webpack_require__, 83935)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(83935)]
  }
});
const Offer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(2732), __webpack_require__.e(6917), __webpack_require__.e(107)]).then(__webpack_require__.bind(__webpack_require__, 56917)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(56917)]
  }
});
const AutoPromo = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3382), __webpack_require__.e(6052)]).then(__webpack_require__.bind(__webpack_require__, 71756)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(71756)]
  }
});
const SuggestedFilters = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3382), __webpack_require__.e(7276)]).then(__webpack_require__.bind(__webpack_require__, 97276)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(97276)]
  }
});

const NltOffersContainer = _ref => {
  let {
    filterMenuIsOpen,
    offers,
    otherOffers,
    bgColor,
    listId = 'nlt_listing',
    listName = 'Offerte noleggio a lungo termine'
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  const {
    items: offerItems
  } = offers;

  const onPaginatorClickHandler = page => dispatch((0,src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_5__/* .setListingPage */ .Dx)(page));

  const listItems = offerItems.filter(offer => offer.code !== 'auto-promo').map((offer, index) => (0,src_utils_gtm__WEBPACK_IMPORTED_MODULE_6__/* .rentOfferToProductItem */ .ck)(offer, {
    index
  }));
  (0,src_utils_gtm__WEBPACK_IMPORTED_MODULE_7__/* .useViewItemList */ .A)({
    items: listItems,
    listId,
    listName
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Grid */ .rj, {
      templateColumns: {
        md: `repeat(${filterMenuIsOpen ? 2 : 3}, 1fr)`,
        lg: `repeat(${filterMenuIsOpen ? 3 : 4}, 1fr)`
      },
      gap: 6,
      pr: "l",
      pt: "l",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SuggestedFilters, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        items: offerItems.map(item => ['https://carplanner.com/noleggio-a-lungo-termine/', item.brandCode, '/', item.modelCode, '/', item.code, '?deposit=', item.deposit, '&contractLength=', item.contractLength, '&annualMileage=', item.annualMileage].join(''))
      }), offerItems.map(item => {
        return item.code === 'auto-promo' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
          display: "inline-grid",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(AutoPromo, {
            item: item
          })
        }, `${item.code}- ${item.title} `) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
          display: "inline-grid",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Offer, {
            item: item,
            index: listItems.findIndex(listItem => listItem.item_id === item.code),
            listId: listId,
            listName: listName
          })
        }, item.code);
      }), offerItems.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        },
        mt: "-2",
        textAlign: "left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Pagination, {
          currentPage: offers.currentPage,
          perPage: offers.pageSize,
          total: offers.results,
          onClick: onPaginatorClickHandler
        })
      }, "load-more") : null]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
      display: offerItems.length ? 'none' : 'block',
      float: "right",
      pl: {
        base: 'l',
        md: 'm'
      },
      pr: "l",
      w: {
        base: '100%',
        md: '75%'
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
        py: "l",
        as: "h3",
        fontSize: "2xl",
        fontFamily: "Montserrat-SemiBold",
        children: t('nltPage:notFound')
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeOffersList, {
        action: t('indexPage:nlt_offers.action'),
        alt: t('indexPage:nlt_offers.alt'),
        bgColor: bgColor || 'baseNeutral.100',
        href: "/noleggio-a-lungo-termine",
        offers: otherOffers,
        trackView: !offerItems.length,
        numPerView: filterMenuIsOpen ? 3 : 4,
        pt: "0"
      })]
    })]
  });
};

const mapStateToProps = (state, ownProps) => ({
  filterMenuIsOpen: state.nlt.filterMenuIsOpen,
  otherOffers: state.nlt.offers,
  offers: state.nlt.filteredOffers,
  ownProps
});

/* harmony default export */ __webpack_exports__["default"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps)(NltOffersContainer));

/***/ }),

/***/ 28173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useViewItemList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99778);
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22988);




/**
 * Emette `view_item_list` quando la lista mostrata cambia davvero.
 *
 * I listing si ri-renderizzano a ogni cambio di filtro o di pagina e l'array
 * `items` è ricostruito ogni volta: la firma sugli id evita di ripetere lo
 * stesso evento a ogni render mantenendo il push su un cambio reale di risultati.
 *
 * L'evento passa da `whenPageReady` perché queste liste arrivano da import
 * dinamici: senza attendere il `page_view` della pagina che le contiene
 * partirebbero con il `page_data` di quella precedente.
 */
function useViewItemList(_ref) {
  let {
    items,
    listId,
    listName,
    enabled = true
  } = _ref;
  const lastSignature = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const queued = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const latest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    items,
    listId,
    listName
  });
  latest.current = {
    items,
    listId,
    listName
  };
  const signature = `${listId}|${items.map(item => item.item_id).join(',')}`;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!enabled) return;
    if (!items.length) return;
    if (lastSignature.current === signature) return;
    lastSignature.current = signature; // Se i risultati cambiano ancora mentre siamo in coda — i filtri del listing
    // che si assestano prima dell'idratazione — non serve una seconda emissione:
    // al flush si legge comunque la lista aggiornata.

    if (queued.current) return;
    queued.current = true;
    (0,_state__WEBPACK_IMPORTED_MODULE_1__/* .whenPageReady */ .lN)(() => {
      queued.current = false;
      (0,_events__WEBPACK_IMPORTED_MODULE_2__/* .pushViewItemList */ .LM)(latest.current);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature, enabled]);
}

/***/ }),

/***/ 29590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tH": function() { return /* binding */ rentOfferToPageMeta; },
  "ck": function() { return /* binding */ rentOfferToProductItem; },
  "np": function() { return /* binding */ sellOfferToPageMeta; },
  "rW": function() { return /* binding */ sellOfferToProductItem; }
});

// UNUSED EXPORTS: rentOfferToOfferData, rentOfferValue, sellOfferToOfferData, sellOfferValue, toNumber

// EXTERNAL MODULE: ./src/utils/gtm/constants.ts
var constants = __webpack_require__(98845);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/utils/gtm/naming.ts
var naming = __webpack_require__(31067);
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.json
var brandRules_namespaceObject = JSON.parse('{"fiat":{"rpl":22,"offerCustomerType":"B2C","offerType":"Finanziamento"},"jeep":{"rpl":27.5,"offerCustomerType":"B2C","offerType":"Finanziamento"},"bmw":{"offerCustomerType":"B2C","offerType":"Leasing"},"toyota":{"offerCustomerType":"B2B","offerType":"Finanziamento"},"peugeot":{"offerCustomerType":"B2C","offerType":"Finanziamento"}}');
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Valori commerciali che variano per brand automotive.
 *
 * Oggi vivono in un JSON versionato ([brandRules.json](./brandRules.json)): sono
 * accordi commerciali che cambiano di rado e che il backend non espone. La
 * lettura passa da `getBrandRules`, così che il giorno in cui l'offers-explorer
 * restituirà questi campi basti cambiare questa implementazione senza toccare
 * i punti di chiamata.
 *
 * Un brand non mappato NON eredita un rpl inventato: la chiave viene omessa.
 */



const DEFAULT_RULES = {
  offerCustomerType: 'B2C',
  offerType: constants/* DEFAULT_OFFER_TYPE */.OJ
};
function getBrandRules(brandCode) {
  const key = (0,naming/* slugSegment */.nL)(brandCode);
  const brandRules = key ? brandRules_namespaceObject[key] : undefined;
  return _objectSpread(_objectSpread({}, DEFAULT_RULES), brandRules);
}
;// CONCATENATED MODULE: ./src/utils/gtm/mappers.ts
/**
 * Dai DTO dell'offers-explorer agli oggetti dello schema dataLayer.
 *
 * Attenzione alla semantica dei prezzi, invertita rispetto a quella intuitiva:
 * `ecommerce.items[].price` è il prezzo di LISTINO, mentre `ecommerce.value` è
 * il prezzo promozionale/corrente. GA4 non sottrae mai `discount` da `price`.
 */



/** Converte in numero positivo; qualunque altro caso diventa `undefined` (chiave omessa). */
function toNumber(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const parsed = typeof value === 'number' ? value : parseFloat(`${value}`);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

const absoluteUrl = path => path ? `${constants/* SITE_ORIGIN */.yp}${path.split('?')[0].split('#')[0]}` : undefined;

const withQuery = path => path ? `${constants/* SITE_ORIGIN */.yp}${path}` : undefined;

const sellOfferPath = offer => {
  var _offer$vehicle, _offer$vehicle2;

  return `/offerte-auto/${((_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.brandCode) ?? offer.brandCode}/${((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.modelCode) ?? offer.modelCode}/${offer.code}`;
};

const rentOfferPath = offer => {
  var _offer$vehicle3, _offer$vehicle4;

  return `/noleggio-a-lungo-termine/${((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.brandCode) ?? offer.brandCode}/${((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.modelCode) ?? offer.modelCode}/${offer.code}`;
};

function sellOfferToProductItem(offer) {
  var _vehicle$engine;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? offer.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine = vehicle.engine) === null || _vehicle$engine === void 0 ? void 0 : _vehicle$engine.fuel;
  const canonicalPath = path || sellOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: vehicle === null || vehicle === void 0 ? void 0 : vehicle.category,
    item_category4: detail.year ? `${detail.year}` : undefined,
    item_category5: version,
    price: toNumber(offer.price),
    currency: constants/* CURRENCY */.wA,
    discount: toNumber(detail.priceReduction),
    image_url: detail.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function rentOfferToProductItem(offer) {
  var _vehicle$engine2, _detail$images, _detail$images$;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const item = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? item.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? item.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? item.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine2 = vehicle.engine) === null || _vehicle$engine2 === void 0 ? void 0 : _vehicle$engine2.fuel;
  const canonicalPath = path || rentOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category) ?? item.category,
    item_category5: version,
    // Il noleggio non espone un prezzo di listino del veicolo: resta omesso.
    price: toNumber(detail.specialPrice),
    currency: constants/* CURRENCY */.wA,
    image_url: ((_detail$images = detail.images) === null || _detail$images === void 0 ? void 0 : (_detail$images$ = _detail$images[0]) === null || _detail$images$ === void 0 ? void 0 : _detail$images$.src) ?? item.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function sellOfferToOfferData(offer) {
  var _offer$vehicle5;

  const brandCode = ((_offer$vehicle5 = offer.vehicle) === null || _offer$vehicle5 === void 0 ? void 0 : _offer$vehicle5.brandCode) ?? offer.brandCode;
  const rules = getBrandRules(brandCode);
  return {
    offer_type: rules.offerType,
    offer_customer_type: rules.offerCustomerType,
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
function rentOfferToOfferData(offer) {
  return {
    offer_type: constants/* RENT_OFFER_TYPE */.y,
    offer_customer_type: offer.customerType === 'piva' ? 'B2B' : 'B2C',
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
/** Prezzo promozionale/corrente del veicolo. */

const sellOfferValue = offer => toNumber(offer.specialPrice) ?? toNumber(offer.price);
/** Per il noleggio l'unico valore economico esposto è il canone mensile. */

const rentOfferValue = offer => toNumber(offer.monthlyRate);

/** Meta di pagina per la VDP sell, pronta per `useGtmPage`. */
function sellOfferToPageMeta(offer) {
  var _vehicle$engine3;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  const brandCode = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode) ?? offer.brandCode;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand,
    model: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine3 = vehicle.engine) === null || _vehicle$engine3 === void 0 ? void 0 : _vehicle$engine3.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(brandCode).rpl,
    productItem: sellOfferToProductItem(offer, {
      path
    }),
    offerData: sellOfferToOfferData(offer),
    value: sellOfferValue(offer)
  };
}
/** Meta di pagina per la VDP noleggio, pronta per `useGtmPage`. */

function rentOfferToPageMeta(offer) {
  var _vehicle$engine4;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand,
    model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine4 = vehicle.engine) === null || _vehicle$engine4 === void 0 ? void 0 : _vehicle$engine4.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode).rpl,
    productItem: rentOfferToProductItem(offer, {
      path
    }),
    offerData: rentOfferToOfferData(offer),
    value: rentOfferValue(offer)
  };
}

/***/ })

}]);